(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["helior-new-arrivals"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('helior-arrivals')) {
    customElements.define('helior-arrivals', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.helior-arrivals__track');
        this.slides = Array.from(this.track.children);
        this.toggle = this.querySelector('[data-toggle]');
        this.current = this.querySelector('[data-current]');
        this.controls = this.querySelector('.helior-arrivals__controls');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.hovered = false;
        this.visible = false;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const stop = () => { this.paused = true; this.sync(); };
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => { stop(); this.advance(Number(button.dataset.direction)); }, options));
        this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
        this.track.addEventListener('pointerdown', stop, options);
        this.track.addEventListener('wheel', stop, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (['ArrowLeft', 'ArrowRight'].includes(event.key)) {
            event.preventDefault(); stop(); this.advance(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.addEventListener('focusin', event => { if (!event.target.closest('[data-toggle]')) stop(); }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); } }, options);
        this.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { this.hovered = false; this.sync(); } }, options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) stop(); }, options);
        this.resize = new ResizeObserver(() => { this.update(); this.sync(); });
        this.resize.observe(this.track);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: 0.25 });
        this.observer.observe(this.track);
        this.update(); this.sync();
      }
      get step() { return this.slides.length > 1 ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : this.track.clientWidth; }
      get maxIndex() { return Math.max(0, Math.round((this.track.scrollWidth - this.track.clientWidth) / this.step)); }
      advance(direction) {
        let index = Math.round(this.track.scrollLeft / this.step) + direction;
        if (index > this.maxIndex) index = 0;
        if (index < 0) index = this.maxIndex;
        this.track.scrollTo({ left: index * this.step, behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
      update() {
        const index = Math.max(0, Math.min(this.maxIndex, Math.round(this.track.scrollLeft / this.step)));
        this.current.textContent = String(index + 1);
        this.controls.hidden = this.maxIndex === 0;
        const rect = this.track.getBoundingClientRect();
        this.slides.forEach(slide => {
          const box = slide.getBoundingClientRect();
          const hidden = box.right <= rect.left + 1 || box.left >= rect.right - 1;
          if (!slide.contains(document.activeElement)) slide.inert = hidden;
        });
      }
      sync() {
        clearInterval(this.timer);
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause);
        this.toggle.querySelector('[data-play-icon]').toggleAttribute('hidden', !this.paused);
        this.toggle.querySelector('[data-pause-icon]').toggleAttribute('hidden', this.paused);
        if (!this.paused && !this.hovered && this.visible && !document.hidden && this.maxIndex > 0) {
          this.timer = setInterval(() => this.advance(1), Number(this.dataset.interval));
        }
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.abort?.abort(); this.resize?.disconnect(); this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["helior-product-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('helior-product-slideshow')) {
    customElements.define('helior-product-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.stage = this.querySelector('.helior-showcase__stage');
        this.controls = this.querySelector('.helior-showcase__controls');
        this.index = 0;
        if (this.slides.length < 2 || !this.controls) return;
        this.controls.hidden = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.visible = true;
        this.querySelector('[data-previous]').addEventListener('click', () => this.manual(this.index - 1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.manual(this.index + 1), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.manual(index), options));
        this.querySelector('[data-toggle]').addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
        this.controls.addEventListener('keydown', (event) => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.manual(this.index + (event.key === 'ArrowRight' ? 1 : -1)); } }, options);
        this.stage.addEventListener('touchstart', (event) => { this.touch = {x:event.touches[0].clientX,y:event.touches[0].clientY}; }, {...options, passive:true});
        this.stage.addEventListener('touchend', (event) => { if (!this.touch) return; const dx=event.changedTouches[0].clientX-this.touch.x; const dy=event.changedTouches[0].clientY-this.touch.y; if (Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.4) this.manual(this.index+(dx<0?1:-1)); this.touch=null; }, {...options,passive:true});
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', (event) => { if(event.matches) { this.paused=true; this.sync(); } }, options);
        this.addEventListener('shopify:block:select', (event) => { const index=this.slides.findIndex(slide=>slide.dataset.blockId===event.detail.blockId); if(index>=0) this.manual(index); }, options);
        this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();});
        this.observer.observe(this);
        this.sync();
      }
      manual(index) { this.show(index); this.sync(); }
      show(index) {
        this.index=(index+this.slides.length)%this.slides.length;
        this.slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===this.index);slide.setAttribute('aria-hidden',String(i!==this.index));});
        this.dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===this.index)));
      }
      sync() {
        this.querySelector('[data-toggle]').setAttribute('aria-label',this.paused?this.dataset.playLabel:this.dataset.pauseLabel);
        this.querySelector('[data-pause-icon]').hidden=this.paused;
        this.querySelector('[data-play-icon]').hidden=!this.paused;
        this.stage.setAttribute('aria-live',this.paused?'polite':'off');
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if(this.paused||!this.visible||document.hidden) return;
        this.timer=setTimeout(()=>{this.show(this.index+1);this.schedule();},Number(this.dataset.interval)||2000);
      }
      disconnectedCallback() { clearTimeout(this.timer);this.observer?.disconnect();this.abort?.abort();this.abort=null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
if (!customElements.get('helior-infinite-scroll')) {
  customElements.define('helior-infinite-scroll', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.controller?.abort();
      this.initialized = false;
    }

    initialize() {
      if (this.initialized || !this.isConnected || !this.dataset.nextUrl || !('IntersectionObserver' in window)) return;
      this.grid = this.parentElement.querySelector('#product-grid');
      this.status = this.querySelector('.helior-scroll-status');
      if (!this.grid || !this.status) return;
      this.initialized = true;
      this.loaded = new Set();
      this.classList.add('helior-scroll-ready');
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.loadNext();
      }, { rootMargin: '0px 0px 480px 0px' });
      this.observer.observe(this);
    }

    async loadNext() {
      if (this.loading || !this.dataset.nextUrl || !this.isConnected || this.closest('.collection')?.classList.contains('loading')) return;
      const pageUrl = new URL(this.dataset.nextUrl, window.location.href);
      if (pageUrl.origin !== window.location.origin || this.loaded.has(pageUrl.href)) return;
      const stateUrl = window.location.href;
      const expectedPage = Number(this.dataset.page) + 1;
      const requestUrl = new URL(pageUrl);
      requestUrl.searchParams.set('section_id', this.dataset.sectionId);
      this.loading = true;
      this.observer.unobserve(this);
      this.controller = new AbortController();
      this.grid.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loadingLabel;
      this.status.classList.remove('visually-hidden');
      const timeout = window.setTimeout(() => this.controller?.abort(), 15000);
      try {
        const response = await fetch(requestUrl.href, { signal: this.controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Page unavailable');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected || window.location.href !== stateUrl || this.closest('.collection')?.classList.contains('loading')) return;
        const nextGrid = parsed.querySelector('#product-grid');
        const nextPager = parsed.querySelector('helior-infinite-scroll');
        if (!nextGrid || !nextGrid.children.length || !nextPager || Number(nextPager.dataset.page) !== expectedPage) throw new Error('Unexpected page');
        const fragment = document.createDocumentFragment();
        Array.from(nextGrid.children).forEach((card) => {
          card.classList.add('scroll-trigger--cancel');
          fragment.appendChild(document.importNode(card, true));
        });
        this.grid.appendChild(fragment);
        this.loaded.add(pageUrl.href);
        this.dataset.page = nextPager.dataset.page;
        this.dataset.nextUrl = nextPager.dataset.nextUrl || '';
        const fallback = nextPager.querySelector('.pagination-wrapper');
        if (fallback) this.querySelector('.pagination-wrapper')?.replaceWith(document.importNode(fallback, true));
        this.status.textContent = this.dataset.countLabel.replace('[count]', String(this.grid.children.length));
        this.status.classList.add('visually-hidden');
        if (this.dataset.nextUrl) this.observer.observe(this);
        else this.classList.add('helior-scroll-complete');
      } catch (error) {
        if (!this.isConnected) return;
        this.classList.remove('helior-scroll-ready');
        this.status.textContent = '';
        this.status.classList.add('visually-hidden');
      } finally {
        window.clearTimeout(timeout);
        this.loading = false;
        this.grid?.removeAttribute('aria-busy');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
